import React, { useEffect, useRef, useState } from "react";
import MainActionButton from "./MainActionButton";

const PanelBody = ({
  loading,
  shouldShowControls,
  error,
  duration,
  setDuration,
  selectedPlace,
  handleGenerateRoute,
  handleSetRoute, // <--- Add this
  setShowControls,
  setSelectedPlace,
  places, // 新增 props: places
}) => {
  // 動畫結束後才隱藏 z-index/移出畫面
  const [hideCompletely, setHideCompletely] = useState(false);
  const [showAnim, setShowAnim] = useState(false); // 新增：進場動畫狀態
  const prevShow = useRef(shouldShowControls);

  useEffect(() => {
    if (!shouldShowControls && prevShow.current) {
      const timer = setTimeout(() => setHideCompletely(true), 400);
      setShowAnim(false); // 收合時直接隱藏動畫
      return () => clearTimeout(timer);
    }
    if (shouldShowControls) {
      setHideCompletely(false);
      // 進場時，先設為隱藏，下一個 tick 切換動畫 class
      setShowAnim(false);
      setTimeout(() => setShowAnim(true), 10); // 10ms 觸發動畫
    }
    prevShow.current = shouldShowControls;
  }, [shouldShowControls]);

  // 完全不渲染，避免物理遮擋
  if (!shouldShowControls && hideCompletely) return null;

  return (
    <div
      className="fixed left-1/2 bottom-0 z-[1010] -translate-x-1/2 w-[98vw] max-w-xl pb-4 transition-all duration-300"
      style={
        !shouldShowControls && hideCompletely
          ? {
              zIndex: 0,
              position: "absolute",
              left: 0,
              right: 0,
              bottom: 0,
              top: 0,
              pointerEvents: "none",
              opacity: 0,
              width: 0,
              height: 0,
              overflow: "hidden",
            }
          : {}
      }
    >
      <div
        className={`bg-[#181c23] rounded-2xl shadow-2xl border border-[#23272f] px-6 py-5 flex flex-col gap-4 relative pb-12 transition-all duration-400 font-sans ${
          showAnim
            ? "translate-y-0 opacity-100 pointer-events-auto"
            : "translate-y-20 opacity-0 pointer-events-none"
        }`}
      >
        {/* 錯誤訊息 */}
        {error && (
          <div className="bg-red-900/90 text-red-200 rounded-lg px-4 py-2 mb-3 shadow-lg border border-red-800 animate-pulse text-center text-sm">
            {error}
          </div>
        )}
        <div className="flex items-center justify-between gap-4 mb-2 w-full">
          {/* 強化版滑桿與分鐘數 */}
          <input
            id="duration-slider"
            type="range"
            min="5"
            max="60"
            step="5"
            value={duration}
            onChange={(e) => setDuration(e.target.value)}
            disabled={loading}
            className="flex-1 h-4 md:h-5 accent-amber-500 bg-[#23272f] rounded-full mx-2 duration-slider-custom"
            style={{ minWidth: 0, maxWidth: 260 }}
          />
          <span className="ml-3 px-4 py-1 rounded-full bg-amber-700 text-white font-bold text-xl md:text-2xl shadow-md border-2 border-amber-300 select-none min-w-[70px] text-center">
            {duration} 分鐘
          </span>
        </div>
        <style>{`
          /* 自訂滑桿樣式 */
          input[type='range'].duration-slider-custom {
            appearance: none;
            width: 100%;
            background: transparent;
          }
          input[type='range'].duration-slider-custom:focus {
            outline: none;
          }
          input[type='range'].duration-slider-custom::-webkit-slider-runnable-track {
            height: 1.1rem;
            background: #23272f;
            border-radius: 0.75rem;
            box-shadow: 0 1px 4px #0004;
          }
          input[type='range'].duration-slider-custom::-webkit-slider-thumb {
            appearance: none;
            width: 2.1rem;
            height: 2.1rem;
            border-radius: 50%;
            background: linear-gradient(135deg, #fbbf24 60%, #f59e42 100%);
            border: 3px solid #fff;
            box-shadow: 0 2px 8px #fbbf2440, 0 0 0 4px #fbbf2420;
            transition: box-shadow 0.2s;
            cursor: pointer;
          }
          input[type='range'].duration-slider-custom:hover::-webkit-slider-thumb,
          input[type='range'].duration-slider-custom:active::-webkit-slider-thumb {
            box-shadow: 0 4px 16px #fbbf2480, 0 0 0 6px #fbbf2430;
          }
          input[type='range'].duration-slider-custom::-moz-range-thumb {
            width: 2.1rem;
            height: 2.1rem;
            border-radius: 50%;
            background: linear-gradient(135deg, #fbbf24 60%, #f59e42 100%);
            border: 3px solid #fff;
            box-shadow: 0 2px 8px #fbbf2440, 0 0 0 4px #fbbf2420;
            transition: box-shadow 0.2s;
            cursor: pointer;
          }
          input[type='range'].duration-slider-custom:hover::-moz-range-thumb,
          input[type='range'].duration-slider-custom:active::-moz-range-thumb {
            box-shadow: 0 4px 16px #fbbf2480, 0 0 0 6px #fbbf2430;
          }
          input[type='range'].duration-slider-custom::-ms-thumb {
            width: 2.1rem;
            height: 2.1rem;
            border-radius: 50%;
            background: linear-gradient(135deg, #fbbf24 60%, #f59e42 100%);
            border: 3px solid #fff;
            box-shadow: 0 2px 8px #fbbf2440, 0 0 0 4px #fbbf2420;
            transition: box-shadow 0.2s;
            cursor: pointer;
          }
          input[type='range'].duration-slider-custom:hover::-ms-thumb,
          input[type='range'].duration-slider-custom:active::-ms-thumb {
            box-shadow: 0 4px 16px #fbbf2480, 0 0 0 6px #fbbf2430;
          }
          input[type='range'].duration-slider-custom::-ms-fill-lower {
            background: #23272f;
            border-radius: 0.75rem;
          }
          input[type='range'].duration-slider-custom::-ms-fill-upper {
            background: #23272f;
            border-radius: 0.75rem;
          }
          input[type='range'].duration-slider-custom:focus::-ms-fill-lower {
            background: #23272f;
          }
          input[type='range'].duration-slider-custom:focus::-ms-fill-upper {
            background: #23272f;
          }
          input[type='range'].duration-slider-custom::-moz-range-track {
            height: 1.1rem;
            background: #23272f;
            border-radius: 0.75rem;
            box-shadow: 0 1px 4px #0004;
          }
          input[type='range'].duration-slider-custom::-ms-tooltip {
            display: none;
          }
        `}</style>
        <div className="flex flex-col gap-2 mt-2">
          {/* 產生路線按鈕，統一圓角主色塊風格 */}
          {!selectedPlace ? (
            <MainActionButton
              onClick={() => {
                setShowControls(false);
                setSelectedPlace(null);
                handleSetRoute({ type: "random" });
              }}
              disabled={loading}
              loading={loading}
            >
              產生路線
            </MainActionButton>
          ) : (
            <MainActionButton
              onClick={() => {
                let lat = null,
                  lng = null;
                if (selectedPlace.geometry && selectedPlace.geometry.location) {
                  if (
                    typeof selectedPlace.geometry.location.lat === "function"
                  ) {
                    lat = selectedPlace.geometry.location.lat();
                    lng = selectedPlace.geometry.location.lng();
                  } else {
                    lat = selectedPlace.geometry.location.lat;
                    lng = selectedPlace.geometry.location.lng;
                  }
                  setShowControls(false);
                  handleSetRoute({
                    type: "random",
                    end_lat: lat,
                    end_lng: lng,
                  });
                }
              }}
              disabled={loading}
              loading={loading}
            >
              {Array.isArray(places) &&
              selectedPlace &&
              places.some((p) => p.place_id === selectedPlace.place_id)
                ? "以此景點為終點"
                : "設為終點"}
            </MainActionButton>
          )}
        </div>
        <style>{`
          /* 主按鈕動畫與滑桿樣式統一 */
          .duration-main-btn {
            transition: box-shadow 0.2s, background 0.2s, border 0.2s;
          }
          .duration-main-btn:hover:not(:disabled),
          .duration-main-btn:focus:not(:disabled) {
            box-shadow: 0 4px 24px #fbbf2480, 0 0 0 6px #fbbf2430;
            background: #f59e42;
            border-color: #fbbf24;
          }
        `}</style>
        {/* 隱藏控制面板按鈕 */}
        <button
          onClick={() => setShowControls(false)}
          aria-label="隱藏控制面板"
          className="absolute left-1/2 -translate-x-1/2 bottom-0 py-2 rounded-lg bg-transparent text-amber-200 hover:text-white transition border-none shadow-none text-base"
          style={{ zIndex: 2 }}
          title="隱藏控制面板"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="h-7 w-7"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
            strokeWidth={2}
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M19 9l-7 7-7-7"
            />
          </svg>
        </button>
      </div>
      <style>{`
        /* 強制 Google Maps 控制按鈕固定在右下，不因面板出現/消失而移動 */
        .gm-control-active[title="地圖攝影機控制項"] {
          right: 2rem !important;
          left: auto !important;
          margin-right: 0 !important;
          bottom: 2rem !important;
          top: auto !important;
          position: fixed !important;
        }
        .gm-control-active {
          transition: none !important;
        }
        menu[style*="right: 100%"] {
          right: 7.5rem !important;
          left: auto !important;
        }
      `}</style>
    </div>
  );
};

export default PanelBody;
